import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../ui/CTAButton';
import { Check } from 'lucide-react';
const benefits = ['Para noivas com orçamento apertado que não querem abrir mão da elegância', "Para noivas inseguras sobre 'fazer feio' no dia mais importante", 'Para quem não sabe fazer artesanato (e nem quer aprender técnicas complicadas)', 'Para quem quer receber elogios sinceros e zero estresse', 'Para quem quer economizar 5 a 10 vezes sem que ninguém perceba'];
export function ProductSection() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-24 bg-white" data-id="element-207">
      <div className="max-w-5xl mx-auto px-6" data-id="element-208">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-209">
          <div className="inline-block bg-gradient-to-r from-rose-100 to-pink-100 px-6 py-2 rounded-full mb-6" data-id="element-210">
            <span className="text-rose-600 font-semibold" data-id="element-211">Apresentando</span>
          </div>

          <h2 className="font-serif text-5xl md:text-6xl font-bold text-gray-900 mb-6" data-id="element-212">
            A Fórmula do{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-rose-500 to-pink-600" data-id="element-213">
              Efeito Boutique™
            </span>
          </h2>

          <p className="text-2xl md:text-3xl text-gray-700 font-light leading-relaxed max-w-4xl mx-auto" data-id="element-214">
            As 40 ideias mais bonitas, elogiadas e econômicas para transformar
            seu casamento —
            <span className="font-semibold" data-id="element-215"> gastando 5 a 10 vezes menos</span>
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2,
        duration: 0.6
      }} className="bg-gradient-to-br from-rose-50 to-pink-50 p-10 rounded-3xl shadow-xl border border-rose-100 mb-12" data-id="element-216">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center" data-id="element-217">
            Este guia é para você se:
          </h3>

          <div className="space-y-4" data-id="element-218">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.4
          }} className="flex items-start gap-4 bg-white p-5 rounded-xl shadow-md" data-id="element-219">
                <div className="bg-green-500 rounded-full p-1 flex-shrink-0 mt-1" data-id="element-220">
                  <Check className="w-5 h-5 text-white" data-id="element-221" />
                </div>
                <p className="text-lg text-gray-700 leading-relaxed" data-id="element-222">
                  {benefit}
                </p>
              </motion.div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4,
        duration: 0.6
      }} className="text-center" data-id="element-223">
          <CTAButton size="large" onClick={scrollToPricing} data-id="element-224">
            Sim, Eu Quero Economizar e Impressionar!
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}